module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-152x152-99594a4130baee58d0f5a5a713a1cc97.png";